const API_BASE = '/api';

async function request(path, options = {}) {
  const { method = 'GET', body, headers, ...rest } = options;
  const response = await fetch(`${API_BASE}${path}`, {
    method,
    body,
    headers: { 'Content-Type': 'application/json', ...(headers || {}) },
    ...rest,
  });
  let data;
  try {
    data = await response.json();
  } catch {
    return { ok: false, error: `请求失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: data.error || `请求失败 (${response.status})` };
  }
  if (!response.ok) {
    return { ok: false, error: data.error || data.detail || `请求失败 (${response.status})` };
  }
  return data;
}

async function uploadFile(path, file) {
  const form = new FormData();
  form.append('file', file);
  const response = await fetch(`${API_BASE}${path}`, { method: 'POST', body: form });
  let data;
  try {
    data = await response.json();
  } catch {
    return { ok: false, error: `上传失败 (${response.status})` };
  }
  if (data.ok === false || !response.ok) {
    return { ok: false, error: data.error || data.detail || '上传失败' };
  }
  return data;
}

export const excelSplitApi = {
  state: () => request('/excel-split/state'),
  upload: (file) => uploadFile('/excel-split/upload', file),
  sheet: (sheetName) => request('/excel-split/sheet', { method: 'POST', body: JSON.stringify({ sheetName }) }),
  preview: (filters) =>
    request('/excel-split/preview', { method: 'POST', body: JSON.stringify({ filters }) }),
  setKinds: (kinds) =>
    request('/excel-split/kinds', { method: 'POST', body: JSON.stringify({ kinds }) }),
  resetKinds: () => request('/excel-split/kinds/reset', { method: 'POST', body: '{}' }),
  run: (payload) => request('/excel-split/run', { method: 'POST', body: JSON.stringify(payload) }),
  reset: () => request('/excel-split/reset', { method: 'POST', body: '{}' }),
  downloadUrl: () => `${API_BASE}/excel-split/download`,
};
